import { Input } from '../Input/Input'

const STEP = 15

interface Props {
  label: string
  value: number
  onChange: (value: number) => void
  step?: number
  error?: string | null
}

export function DurationSpinner({ label, value, onChange, step = STEP, error }: Props) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-sm font-medium text-gray-700">{label}</span>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => onChange(Math.max(0, value - step))}
          className="w-11 h-11 shrink-0 rounded-full border border-gray-300 text-xl font-bold text-gray-600 flex items-center justify-center"
        >
          −
        </button>
        <Input
          type="number"
          min={0}
          step={step}
          value={value}
          onChange={(val) => onChange(Math.max(0, Number(val)))}
          error={error ?? null}
        />
        <button
          type="button"
          onClick={() => onChange(value + step)}
          className="w-11 h-11 shrink-0 rounded-full border border-gray-300 text-xl font-bold text-gray-600 flex items-center justify-center"
        >
          +
        </button>
      </div>
    </div>
  )
}
